import { useRef } from 'react';
import styled from 'styled-components';
import { Card, CardHeader, StepNumber, Notice, Hint, color } from '../App.styles';

function TemplateCard({ mode, template, uploading, onSelectDefault, onUpload }) {
  const fileRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (file) onUpload(file);
  };

  return (
    <Card>
      <CardHeader>
        <StepNumber>1</StepNumber>
        <h2>템플릿</h2>
      </CardHeader>

      <OptionGrid>
        <Option $active={mode === 'default'} onClick={onSelectDefault}>
          <strong>기본 템플릿 사용</strong>
          <span>양식이 없는 경우</span>
        </Option>
        <Option $active={mode === 'custom'} onClick={() => fileRef.current.click()} disabled={uploading}>
          <strong>내 템플릿 업로드</strong>
          <span>{uploading ? '양식 분석 중...' : template ? template.filename : '보유한 양식 그대로'}</span>
        </Option>
      </OptionGrid>
      <input ref={fileRef} type="file" accept=".docx" hidden onChange={handleFileChange} />

      {uploading && <Hint>AI가 양식에서 항목별로 채울 자리를 찾고 있습니다. 잠시만 기다려 주세요.</Hint>}

      {mode === 'custom' && template && !uploading && (
        <>
          {template.recognized.length === 0 ? (
            <Notice>
              양식에서 채울 자리를 찾지 못했습니다. 양식에 <b>$회의 내용$</b>처럼 항목 이름을 $로 감싸 적어 주세요.
            </Notice>
          ) : (
            <Recognized>
              <p>{template.mode === 'auto' ? '이렇게 인식했어요' : '$항목$ 표시를 찾았어요'}</p>
              <ul>
                {template.recognized.map(({ label, where }) => (
                  <li key={label}>
                    <b>{label}</b>
                    <span>{where}</span>
                  </li>
                ))}
              </ul>
            </Recognized>
          )}
          {template.recognized.length > 0 && template.missing.length > 0 && (
            <Notice>양식에 자리가 없어 채우지 않는 항목: {template.missing.join(', ')}</Notice>
          )}
          {template.mode === 'auto' && template.recognized.length > 0 && (
            <Hint>
              위치가 틀렸다면 양식에서 해당 자리에 <b>$항목 이름$</b>을 적어 다시 올려 주세요. 표시가 있으면 표시를
              우선합니다.
            </Hint>
          )}
        </>
      )}
    </Card>
  );
}

const Recognized = styled.div`
  margin-top: 12px;
  padding: 12px 14px;
  background-color: ${color.bgSoft};
  border: 1px solid ${color.borderLight};
  border-radius: 8px;
  font-size: 13px;

  p {
    margin-bottom: 8px;
    font-weight: 700;
    color: ${color.primary};
  }

  li {
    display: flex;
    gap: 12px;
    line-height: 1.8;
  }

  b {
    flex: 0 0 72px;
    font-weight: 500;
    color: ${color.text};
  }

  span {
    color: ${color.textSub};
  }
`;

const OptionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Option = styled.button`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background-color: ${(props) => (props.$active ? color.primaryLight : '#fff')};
  border: 1px solid ${(props) => (props.$active ? color.primary : color.border)};
  border-radius: 10px;
  text-align: left;

  strong {
    font-size: 15px;
    font-weight: 700;
    color: ${(props) => (props.$active ? color.primary : color.text)};
  }

  span {
    overflow: hidden;
    font-size: 13px;
    color: ${color.textMuted};
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export default TemplateCard;
